export default __webpack_public_path__ + "static/media/trash-2.3109eb75.svg";